//import forge from "node-forge"
//const crypto = require("crypto");
// const { v4: uuid } = require("uuid");

// const fs = require("fs");
// const { TextEncoder, TextDecoder } = require("util");

//console.log("FUNC", crypto);

class SdkInfo {
  constructor(context) {
    // localStorage.setItem("saap/sdkid", "");
    this.context = context;
    this.sdkId = localStorage.getItem("saap/sdkid");
    this.sdkKey = localStorage.getItem("saap/sdkpub");
    this.sdkPrivateKey = localStorage.getItem("saap/sdkpvt");
    this.deviceId = this.getDevId(context);

    if (!this.sdkId || !this.sdkKey || !this.sdkPrivateKey) {
      (async () => {
        await this.generateInfo();
        localStorage.setItem("saap/sdkid", this.sdkId);
        localStorage.setItem("saap/sdkpub", this.sdkKey);
        localStorage.setItem("saap/sdkpvt", this.sdkPrivateKey);
      })();
    }

    this.dump();
  }

  async generateRSAKeyPair() {
    const keyPair = await window.crypto.subtle.generateKey(
      {
        name: "RSA-OAEP",
        modulusLength: 1024, // Can be 1024, 2048, or 4096
        publicExponent: new Uint8Array([0x01, 0x00, 0x01]), // Common value (65537)
        hash: { name: "SHA-256" }, // or SHA-1, SHA-384, SHA-512
      },
      true, // Whether the key is extractable (i.e., can be used in exportKey)
      ["encrypt", "decrypt"] // Key usages
    );

    //console.log("Keypair Generated..", keyPair.publicKey, keyPair.privateKey);

    const publicKey = await window.crypto.subtle.exportKey(
      "spki",
      keyPair.publicKey
    );
    const privateKey = await window.crypto.subtle.exportKey(
      "pkcs8",
      keyPair.privateKey
    );

    return {
      publicKey: this.arrayBufferToPem(publicKey, "PUBLIC KEY"),
      privateKey: this.arrayBufferToPem(privateKey, "PRIVATE KEY"),
    };
  }

  // Helper function to convert ArrayBuffer to Base64 string and wrap it in PEM format
  arrayBufferToPem(buffer, type) {
    const base64String = this.arrayBufferToBase64(buffer);
    const pemString = `-----BEGIN ${type}-----\n${this.formatBase64String(
      base64String
    )}\n-----END ${type}-----\n`;
    return pemString;
  }

  // Helper function to convert ArrayBuffer to Base64 string
  arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  // Helper function to format Base64 string into 64-character lines for PEM
  formatBase64String(base64String) {
    const lineLength = 64;
    const lines = [];
    for (let i = 0; i < base64String.length; i += lineLength) {
      lines.push(base64String.substr(i, lineLength));
    }
    return lines.join("\n");
  }

  getDevId(context) {
    // Ths is the terminal device id which is extracted from QR scanning
    return "saapdevtab2";
  }

  saveFrameParams(params) {
    const data = JSON.stringify(params);
    localStorage.setItem("saap/frm", data);
  }

  loadFrameParams() {
    const data = localStorage.getItem("saap/frm");
    return JSON.parse(data);
  }

  async generateInfo() {
    this.sdkId = "iRVUCzEMSAem65VbBovAPA==";
    // const uid = uuid();
    // const src = Buffer.from(uid.replace(/-/g, ""), "hex");
    // this.sdkId = src.toString("base64").substring(0, 22);
    const { publicKey, privateKey } = await this.generateRSAKeyPair();
    this.sdkKey = publicKey;
    this.sdkPrivateKey = privateKey;
  }

  publicKeyAsXml(publicKey) {
    const keyObject = crypto.createPublicKey(publicKey);
    const modulus =
      keyObject.asymmetricKeyType === "rsa"
        ? keyObject.export({ format: "der", type: "pkcs1" }).slice(22, 126)
        : Buffer.alloc(0);
    const exponent =
      keyObject.asymmetricKeyType === "rsa"
        ? keyObject.export({ format: "der", type: "pkcs1" }).slice(126)
        : Buffer.alloc(0);
    const encodedModulus = modulus.toString("base64");
    const encodedExponent = exponent.toString("base64");
    return `<RSAKeyValue><Modulus>${encodedModulus}</Modulus><Exponent>${encodedExponent}</Exponent></RSAKeyValue>`;
  }

  setPref(key, value) {
    localStorage.setItem(key, value);
    return true;
  }

  getPref(key) {
    return localStorage.getItem(key);
  }

  getSdkId() {
    return Buffer.from(this.sdkId, "base64");
  }

  async getPrivateKey() {
    try {
      return await this.importPrivateKeyFromPem(this.sdkPrivateKey);
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async importPrivateKeyFromPem(pem) {
    // Remove the PEM header and footer
    const pemHeader = "-----BEGIN PRIVATE KEY-----";
    const pemFooter = "-----END PRIVATE KEY-----";
    const pemContents = pem
      .replace(pemHeader, "")
      .replace(pemFooter, "")
      .replace(/\s+/g, "");

    // Decode the Base64 string
    const binaryDerString = window.atob(pemContents);
    const binaryDer = this.str2ab(binaryDerString);

    // Import the key
    return await window.crypto.subtle.importKey(
      "pkcs8", // Import format
      binaryDer, // The decoded key
      {
        name: "RSA-OAEP",
        hash: { name: "SHA-256" }, // Must match the algorithm used to generate the key
      },
      true, // Whether the key is extractable (i.e., can be used in exportKey)
      ["decrypt"] // Key usages
    );
  }

  // Helper function to convert a binary string to an ArrayBuffer
  str2ab(str) {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    }
    return buf;
  }

  dump() {
    console.log("SdkId:", this.sdkId);
    console.log("SdkKey:", this.sdkKey);
    console.log("SdkPrivateKey:", this.sdkPrivateKey);
  }

  toJson() {
    const info = {
      sdkId: this.sdkId,
      sdkKey: this.sdkKey,
      sdkPrivateKey: this.sdkPrivateKey,
    };
    return JSON.stringify(info);
  }

  toServer() {
    const sdkData = {
      sdkId: this.sdkId,
      sdkKey: this.sdkKey,
    };
    return JSON.stringify(sdkData);
  }
}

export default SdkInfo;
